import { CenteredColumn } from 'src/components/DUP/molecules/WizardProofOfIncome/styles';
import { StyledText } from 'src/pages/DUPPage/styles';
import styled from 'styled-components';

export const StyledTag = styled.span`
  padding: 6px;
  border-radius: 4px;
  background: ${({ theme }) => theme.redesignColor.snappt[50]};
  color: ${({ theme }) => theme.redesignColor.gray[700]};
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  width: fit-content;
`;

export const ConnectedAccounts = styled(CenteredColumn)`
  gap: 4px;
  border-radius: 4px;
  border-width: 2px;
  background: ${({ theme }) => theme.redesignColor.gray[100]};
  width: 100%;
  padding: 1rem 1.5rem;
  align-items: start;
`;

export const ConnectedAccount = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0px;
  width: 100%;
`;

export const AccountLogoImage = styled.img`
  width: 40px;
  height: 40px;
`;

export const AccountText = styled(StyledText)`
  padding-left: 10px;
  font-size: 14px;
  font-weight: 600;
  flex: 1;
`;

export const DisconnectLink = styled.a`
  padding-left: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.redesignColor.snappt[500]};
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
`;
